import { IPaymentIntent } from './../interfaces/payment-intent.interface';
import { http } from '../utils/axios';
import { TTransactionsResponse, TCurrentTransaction } from './../types';

class TransactionsService {
  private static instance: TransactionsService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): TransactionsService {
    if (!TransactionsService.instance) {
      TransactionsService.instance = new TransactionsService();
    }

    return TransactionsService.instance;
  }

  getAllTransactions = async () => {
    const { data } = await http<TTransactionsResponse>({
      url: '/transactions',
      method: 'GET'
    });

    return data;
  };

  getOneTransaction = async (payload: TCurrentTransaction) => {
    const { data } = await http<IPaymentIntent>({
      url: `/transactions/${payload.id}`,
      method: 'GET'
    });

    return data;
  };
}

const instance = TransactionsService.getInstance();

export default instance;
